import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=epic%20cinematic%20movie%20theater%20with%20dramatic%20red%20velvet%20curtains%2C%20warm%20golden%20spotlight%2C%20classic%20hollywood%20elegance%2C%20dark%20theater%20atmosphere%2C%20ornate%20architectural%20details%2C%20rich%20textures%2C%20grand%20scale%2C%20moody%20cinematic%20lighting&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="欧美大片推荐 - 高清电影资源推荐平台"
        title="欧美大片在线观看·高清资源推荐"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
            发现值得一看的
            <br />
            <span className="text-accent-500">欧美大片</span>
          </h1>
          <p className="mt-4 md:mt-6 text-base md:text-lg text-background-200 max-w-xl mx-auto leading-relaxed">
            涵盖好莱坞动作、科幻、悬疑、爱情等热门类型，高清在线观看指南与最新上映资讯，助你畅享顶级视听体验
          </p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/action"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              探索热门大片
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/sci-fi"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              科幻巨制推荐
              <i className="ri-rocket-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}